module.exports = __webpack_public_path__ + "img/checklogo1.1864f87b.png";